const appcuesCli = window.Appcues;

export function setUserOnboarding(company) {
  if (appcuesCli)
    appcuesCli.identify(`${company.id}`, {
      companyName: company.companyName,
      pricingType: company.pricingType,
      country: company.country && company.country.ISO2Code,
      language: company.country && company.country.language,
    });
}

export function setPageOnboarding() {
  if (appcuesCli) appcuesCli.page();
}

export function trackOnboarding(message, data = null) {
  if (appcuesCli) appcuesCli.track(message, data);
}
